import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ROUTES } from './constants/route.constant';
import { authService } from './services';
import AdminLayout from './components/AdminLayout';
import LoginScreen from './screens/LoginScreen';
import DashboardScreen from './screens/DashboardScreen';
import NotificationScreen from './screens/NotificationScreen';
import WithdrawalsScreen from './screens/WithdrawalsScreen';
import MockedTeachersScreen from './screens/MockedTeachersScreen';
import LiveTeachersScreen from './screens/LiveTeachersScreen';
import TutorLeadsScreen from './screens/TutorLeadsScreen';
import MarketingScreen from './screens/MarketingScreen';
import VerificationsScreen from './screens/VerificationsScreen';

const PrivateRoute: React.FC<{
  exact?: boolean;
  path: string;
  component: React.ComponentType<any>;
  // When true, only full-access admins may open the route; restricted admins
  // are bounced to the dashboard (mirrors the hidden nav item).
  fullAccess?: boolean;
}> = ({ component: Component, fullAccess, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (!authService.isLoggedIn) return <Redirect to={ROUTES.LOGIN} />;
      if (fullAccess && !authService.isFullAccess) return <Redirect to={ROUTES.DASHBOARD} />;
      return (
        <AdminLayout>
          <Component {...props} />
        </AdminLayout>
      );
    }}
  />
);

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={ROUTES.LOGIN} component={LoginScreen} />
        <PrivateRoute exact path={ROUTES.DASHBOARD} component={DashboardScreen} />
        <PrivateRoute exact path={ROUTES.NOTIFICATIONS} component={NotificationScreen} fullAccess />
        <PrivateRoute exact path={ROUTES.WITHDRAWALS} component={WithdrawalsScreen} />
        <PrivateRoute exact path={ROUTES.MOCKED_TEACHERS} component={MockedTeachersScreen} />
        <PrivateRoute exact path={ROUTES.LIVE_TEACHERS} component={LiveTeachersScreen} />
        <PrivateRoute exact path={ROUTES.TUTOR_LEADS} component={TutorLeadsScreen} />
        <PrivateRoute exact path={ROUTES.MARKETING} component={MarketingScreen} fullAccess />
        <PrivateRoute exact path={ROUTES.VERIFICATIONS} component={VerificationsScreen} />
        <Redirect to={ROUTES.DASHBOARD} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
